module.exports = __webpack_public_path__ + "static/assets/cd95c9580f2656287db179613b428888.gif";